const trustItems = [
  { icon: "ri-check-double-line", label: "Daily Updates" },
  { icon: "ri-shield-check-line", label: "QC Verified" },
  { icon: "ri-ship-line", label: "Shipping Guide" },
  { icon: "ri-secure-payment-line", label: "Safe Shopping" },
  { icon: "ri-user-star-line", label: "Beginner Friendly" },
];

export default function Hero() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20lifestyle%20flat%20lay%20composition%20on%20light%20warm%20gray%20textured%20surface%2C%20curated%20arrangement%20of%20premium%20sneakers%20leather%20watch%20sunglasses%20and%20soft%20cashmere%20scarf%2C%20natural%20diffused%20window%20lighting%20from%20upper%20left%2C%20editorial%20aesthetic%20with%20intentional%20negative%20space%2C%20warm%20earth%20tones%20with%20touches%20of%20olive%20and%20terracotta%2C%20sophisticated%20minimal%20product%20photography%2C%20soft%20gentle%20shadows%2C%20aspirational%20modern%20aesthetic&width=1800&height=1200&seq=hero-bg-vigorbuy-v3&orientation=landscape"
          alt="Vigorbuy Spreadsheet - Curated product finds and shopping guide"
          title="Vigorbuy Spreadsheet - Best Product Finds 2026"
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/55 via-foreground-950/35 to-foreground-950/55"></div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 md:px-10 text-center pt-20 pb-16">
        {/* H1 */}
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-background-50 leading-tight mb-6 tracking-tight font-heading">
          Vigorbuy Spreadsheet
          <br />
          <span className="text-2xl md:text-4xl lg:text-5xl font-medium text-background-50/85">
            The Ultimate Shopping Guide &amp; Best Finds 2026
          </span>
        </h1>

        {/* Subheading */}
        <p className="text-base md:text-lg text-background-50/75 max-w-2xl mx-auto mb-10 leading-relaxed">
          Discover the latest Vigorbuy Spreadsheet, verified product finds, QC guides,
          shipping tutorials, and expert buying tips. Updated daily with the newest
          products and trusted recommendations.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-14">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-lg text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all duration-200 hover:scale-[1.02]"
          >
            Explore Spreadsheet
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 font-semibold rounded-lg text-sm border border-background-50/30 whitespace-nowrap cursor-pointer hover:bg-background-50/25 transition-all duration-200 hover:scale-[1.02]"
          >
            Vigorbuy Sheet
            <i className="ri-external-link-line ml-2"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-accent-500 text-background-50 font-semibold rounded-lg text-sm whitespace-nowrap cursor-pointer hover:bg-accent-600 transition-all duration-200 hover:scale-[1.02]"
          >
            Buy It Now
            <i className="ri-shopping-cart-line ml-2"></i>
          </a>
        </div>

        {/* Trust Bar */}
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-8">
          {trustItems.map((item) => (
            <div key={item.label} className="flex items-center gap-2 text-background-50/80">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${item.icon} text-sm text-accent-400`}></i>
              </div>
              <span className="text-xs md:text-sm font-medium whitespace-nowrap">{item.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-background-50/40 rounded-full flex items-start justify-center p-1.5">
          <div className="w-1.5 h-3 bg-background-50/60 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}